/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A lender button on the interest, offer or decline page (TXN-3532): for a lender in API mode the resident gives a
 * first and last name, email and phone, and ticks the consent to share them with that lender.
 * 
 * `lender_connection` is the lender's built-in connection id from the page's lender block (`connection`). The consent
 * text itself is not sent: the server stores its own copy, the one the page showed (`consent_text` of the lender).
 * @export
 * @interface HomeownershipLenderRequest
 */
export interface HomeownershipLenderRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLenderRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLenderRequest
     */
    lenderConnection: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLenderRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLenderRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLenderRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLenderRequest
     */
    phone: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipLenderRequest
     */
    consentAccepted: boolean;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipLenderRequest
     */
    lenderConsentVersion: number;
}

/**
 * Check if a given object implements the HomeownershipLenderRequest interface.
 */
export function instanceOfHomeownershipLenderRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "lenderConnection" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "phone" in value;
    isInstance = isInstance && "consentAccepted" in value;
    isInstance = isInstance && "lenderConsentVersion" in value;

    return isInstance;
}

export function HomeownershipLenderRequestFromJSON(json: any): HomeownershipLenderRequest {
    return HomeownershipLenderRequestFromJSONTyped(json, false);
}

export function HomeownershipLenderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLenderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'lenderConnection': json['lender_connection'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'phone': json['phone'],
        'consentAccepted': json['consent_accepted'],
        'lenderConsentVersion': json['lender_consent_version'],
    };
}

export function HomeownershipLenderRequestToJSON(value?: HomeownershipLenderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'lender_connection': value.lenderConnection,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
        'phone': value.phone,
        'consent_accepted': value.consentAccepted,
        'lender_consent_version': value.lenderConsentVersion,
    };
}

